import React from "react";
import { Form, Input, Select, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
// import { USER_GROUP_ENUM } from "..";
import { useTranslation } from "react-i18next";
import { NotificationType } from "../../../../../hooks/api/notifications";
import PhoneNumberInput from "../../../../Common/PhoneNumberInput";
import AlternativePhoneInput from "../../../../Common/AlternativePhoneInput";
import { enumToOptionsArray } from "../../../../../utils";
import { UserRoleDisplay } from "../../../../../enums/user";

export default function UserCreateForm(): React.ReactElement {
  const form = Form.useFormInstance();
  const { t } = useTranslation();

  // const userGroupOptions = Object.entries(USER_GROUP_ENUM).map(
  //   ([value, obj]) => ({
  //     value,
  //     label: obj.text,
  //   }),
  // );
  const notificationTypeOptions = Object.entries(NotificationType).map(
    ([value, label]) => ({
      value,
      label: value,
    }),
  );

  return (
    <>
      <Form.Item label="Role" name="role" rules={[{ required: true }]}>
        <Select
          placeholder="Select"
          options={enumToOptionsArray(UserRoleDisplay)}
        />
      </Form.Item>
      <Form.Item
        label="Full Name"
        name="fullName"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <Input placeholder="Type here" />
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <Input placeholder="Type here" />
      </Form.Item>
      <Form.Item
        label="Phone"
        name="phone"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <AlternativePhoneInput />
      </Form.Item>
      <Form.Item
        label="Address"
        name="address"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <Input placeholder="e.g., 2118 Thornridge Cir. Syracuse, Connecticut 35624" />
      </Form.Item>
    </>
  );
}
